<template>
<span>

    <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
        <v-container fluid>
            <v-row>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <select2 v-model="storegiftlist.user_id" :options="usuarios" :settings="{width: '100%', placeholder: 'Selecione um Usuário...'}"></select2>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nvo_nome" :rules="rules.stor_gf_nvo_nomeRules" label="Nome do Noivo" outlined required></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nvo_pai" label="Nome Pai do Noivo" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nvo_mae" label="Nome Mãe do Noivo" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nva_nome" :rules="rules.stor_gf_nva_nomeRules" label="Nome da Noiva" outlined required></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nva_pai" label="Nome do Pai da Noiva" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nva_mae" label="Nome da Mãe da Noiva" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_data_casamento" :rules="rules.dataCasamentoRules" label="Data do Casamento" v-mask="'##/##/####'" outlined required></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nvo_email" :rules="rules.stor_gf_nvo_emailRules" label="Email" outlined required></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <p class="title teal--text lighten-1">Dados da Igreja</p>
                    <v-divider horizontal></v-divider>
                </v-col>

               <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_igreja" label="Nome da Igreja" outlined></v-text-field>
                </v-col>

               <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_end_igreja" label="Endereço" outlined></v-text-field>
                </v-col>

               <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_bairro_igreja" label="Bairro" outlined></v-text-field>
                </v-col>

               <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_compl_igreja" label="Complemento" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <p class="title teal--text lighten-1">Dados da Festa</p>
                    <v-divider horizontal></v-divider>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_local_festa" label="Local" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_end_festa" label="Endereço" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_bairro_festa" label="Bairro" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_compl_festa" label="Complemento" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-textarea v-model="storegiftlist.stor_gf_mais_info_festa" :counter="600" label="Mais Informações" outlined></v-textarea>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <p class="title teal--text lighten-1">Dados da Entrega antes do casamento</p>
                    <v-divider horizontal></v-divider>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nome_entrega_antes" label="Nome" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_cep_antes" label="CEP" outlined @blur="getEnderecoAntesByCEP(storegiftlist.stor_gf_cep_antes)"></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_endereco_antes" label="Endereço" outlined disabled></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_num_antes" label="Numero" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_bairro_antes" label="Bairro" outlined disabled></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_cidade_antes" label="Cidade" outlined disabled></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_uf_antes" label="Estado" outlined disabled></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_fone_antes" label="Telefone" v-mask="'(##) ####-####'" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_celular_antes" label="Celular" v-mask="'(##) #-####-####'" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <p class="title teal--text lighten-1">Dados da Entrega após o casamento</p>
                    <v-divider horizontal></v-divider>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_nome_entrega_pos" label="Nome" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_cep_pos" label="CEP" outlined @blur="getEnderecoPosByCEP(storegiftlist.stor_gf_cep_pos)"></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_endereco_pos" label="Endereço" outlined disabled></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_num_pos" label="Numero" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_bairro_pos" label="Bairro" outlined disabled></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_cidade_pos" label="Cidade" outlined disabled></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_uf_pos" label="Estado" outlined disabled></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_fone_pos" label="Telefone" v-mask="'(##) ####-####'" outlined></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="12" md="6" lg="4" xl="3">
                    <v-text-field v-model="storegiftlist.stor_gf_celular_pos" label="Celular" v-mask="'(##) #-####-####'" outlined></v-text-field>
                </v-col>

               <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-switch color="lime" v-model="storegiftlist.stor_gf_status" label="Status"></v-switch>
                </v-col>

               <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                    <v-btn class="btn-salvar" :disabled="!valid" color="success" @click="onSubmit">
                        <v-icon class="mdi mdi-check mr-2"></v-icon>{{btnLabel}}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../../config/configs'
import cep from "cep-promise";
import Select2 from 'v-select2-component'

export default {
    name: "FormStoreGiftListComponent",
    props: {
        storegiftlist: {
            require: false,
            type: Object | Array,
            default: () => {
                return {
                    stor_gf_id: '',
                    user_id: '',
                    stor_gf_nvo_email: '',
                    stor_gf_nvo_nome: '',
                    stor_gf_nvo_pai: '',
                    stor_gf_nvo_mae: '',
                    stor_gf_nva_nome: '',
                    stor_gf_nva_pai: '',
                    stor_gf_nva_mae: '',
                    prod_meta_descricao: '',
                    stor_gf_mais_info_festa: '',
                    stor_gf_data_casamento: '',
                    stor_gf_igreja: '',
                    stor_gf_end_igreja: '',
                    stor_gf_bairro_igreja: '',
                    stor_gf_compl_igreja: '',
                    stor_gf_local_festa: '',
                    stor_gf_end_festa: '',
                    stor_gf_bairro_festa: '',
                    stor_gf_compl_festa: '',
                    stor_gf_mesmo_end_cad: 0,
                    stor_gf_nome_entrega_antes: '',
                    stor_gf_endereco_antes: '',
                    stor_gf_num_antes: '',
                    stor_gf_cep_antes: '',
                    stor_gf_bairro_antes: '',
                    stor_gf_cidade_antes: '',
                    stor_gf_uf_antes: '',
                    stor_gf_fone_antes: '',
                    stor_gf_celular_antes: '',
                    stor_gf_mesmo_end_antes: 0,
                    stor_gf_nome_entrega_pos: '',
                    stor_gf_endereco_pos: '',
                    stor_gf_num_pos: '',
                    stor_gf_cep_pos: '',
                    stor_gf_bairro_pos: '',
                    stor_gf_cidade_pos: '',
                    stor_gf_uf_pos: '',
                    stor_gf_fone_pos: '',
                    stor_gf_celular_pos: '',
                    stor_gf_status: true,
                    stor_gf_finalizada: false,

                }
            }
        },
        update: {
            require: false,
            type: Boolean,
            default: false
        },
        btnLabel: {
            require: false,
            type: String,
            default: 'Salvar'
        },
        require: true,
    },
    created() {
        this.$store.dispatch('loadUsersAll');
    },
    computed: {
        usuarios() {
            return this.$store.state.users.all.data
        },
    },
    watch: {

    },

    data() {
        return {
            valid: true,
            rules: {
                stor_gf_nvo_nomeRules: [
                    v => !!v || 'Campo Nome do Noivo é obrigatório',
                ],
                stor_gf_nva_nomeRules: [
                    v => !!v || 'Campo Nome da Noiva é obrigatório',
                ],
                dataCasamentoRules: [
                    v => !!v || 'Campo Data do Casamento é obrigatório',
                ],
                stor_gf_nvo_emailRules: [
                    v => !!v || 'Campo E-Mail é obrigatório',
                    v => /.+@.+/.test(v) || 'E-mail precisa ser válido'
                ],
            },
            base_url: URL_BASE
        }
    },
    methods: {
        log(msg) {
            console.log(msg)
        },
        onSubmit() {

            const action = this.update ? 'updateStoreGiftList' : 'storeStoreGiftList';
            const msg = this.update ? 'Dados atualizados com sucesso' : 'Cadastro efetuado com sucesso';

            this.$store.dispatch(action, this.storegiftlist)
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: msg,
                        showConfirmButton: true,
                        timer: 6000
                    });
                    this.$router.push({
                        name: 'store-gift-lists'
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Erro',
                        text: 'Algo deu errado',
                        showConfirmButton: true,
                        timer: 6000
                    });
                    this.errors = error.response.data.errors
                })

        },
        validate() {
            if (this.$refs.form.validate()) {
                this.snackbar = true
            }
        },
        getEnderecoAntesByCEP(stor_gf_cep_antes) {
            let c = stor_gf_cep_antes.replace(/\D/g, '');
            if (c !== "") {

                let validacep = /^[0-9]{8}$/;

                if (validacep.test(c)) {
                    cep(c)
                        .then(response => {

                            this.storegiftlist.stor_gf_endereco_antes = response.street;
                            this.storegiftlist.stor_gf_bairro_antes = response.neighborhood;
                            this.storegiftlist.stor_gf_cidade_antes = response.city;
                            this.storegiftlist.stor_gf_uf_antes = response.state;

                        })
                        .catch(error => {
                            console.log(error)
                        })
                } else {
                    this.$swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Formato do CEP inválido.',
                        showConfirmButton: true,
                        timer: 3000
                    });
                }

            } else {
                this.$swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'O CEP é requerido.',
                    showConfirmButton: true,
                    timer: 3000
                });
            }

        },
        getEnderecoPosByCEP(stor_gf_cep_pos) {
            let c = stor_gf_cep_pos.replace(/\D/g, '');
            if (c !== "") {

                let validacep = /^[0-9]{8}$/;

                if (validacep.test(c)) {
                    cep(c)
                        .then(response => {

                            this.storegiftlist.stor_gf_endereco_pos = response.street;
                            this.storegiftlist.stor_gf_bairro_pos = response.neighborhood;
                            this.storegiftlist.stor_gf_cidade_pos = response.city;
                            this.storegiftlist.stor_gf_uf_pos = response.state;

                        })
                        .catch(error => {
                            console.log(error)
                        })
                } else {
                    this.$swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Formato do CEP inválido.',
                        showConfirmButton: true,
                        timer: 3000
                    });
                }

            } else {
                this.$swal.fire({
                    position: 'center',
                    icon: 'warning',
                    title: 'O CEP é requerido.',
                    showConfirmButton: true,
                    timer: 3000
                });
            }

        },
    },
    components: {
        select2: Select2
    },
};
</script>

<style scoped>
.theme--dark.v-sheet {
    background-color: #303030;
    border-color: #303030;
    color: #fff;
    box-shadow: none;
}

.btn-salvar {
    margin: 0;
}

.form-control {
height: 4.5rem;
}


</style>
